module.exports = __webpack_public_path__ + "img/ugglan.d1d28b6e.png";